import {InputProps} from '@chakra-ui/react';
import React, {ChangeEventHandler} from 'react';
import {forwardRef, memo} from 'react';
import {BsCalendar2} from 'react-icons/bs';
import {UiIcon, UiInput, UiInputGroup, UiInputRightElement} from '~/components/elements';

export interface Props extends InputProps {
  value?: string | undefined;
  onClick?: () => void;
  onChange?: (value?: any) => void;
}

const DatePickerCustomInput = forwardRef(({value, onClick, onChange, ...rest}: Props, ref: any) => (
  <UiInputGroup>
    <UiInput
      ref={ref}
      variant="filled"
      fontWeight="600"
      value={value}
      onClick={onClick}
      onChange={onChange}
      {...rest}
    />
    <UiInputRightElement zIndex={0} top="50%" transform="translateY(-50%)">
      <UiIcon as={BsCalendar2} onClick={onClick} _hover={{cursor: 'pointer'}} />
    </UiInputRightElement>
  </UiInputGroup>
));

export default memo(DatePickerCustomInput);
